import React from 'react';

/**
 * Akali institutional brand mark — bicolor wordmark.
 * • SVG symbol (32×32) — abstract "A" mark
 * • Wordmark "Akali" in #F0ECF8 + "AI" in #F18859
 * • Clash Display 600, 20px
 *
 * Used by the Landing Page navbar and footer to match the institutional
 * site (akaliai.com.br). NOT used inside the authenticated app — the
 * authenticated app keeps the original AkaliLogo (raster).
 */
export const LogoBicolor = ({ size = 20, symbolSize = 32, className = '' }) => (
  <div
    className={`inline-flex items-center gap-2 ${className}`}
    style={{ fontFamily: "'Clash Display', system-ui, sans-serif" }}
    aria-label="Akali AI"
  >
    <svg
      width={symbolSize}
      height={symbolSize}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-hidden="true"
    >
      {/* Official institutional symbol (akaliai.com.br) — dual arcs + signal bars */}
      <path d="M13 6 A10 10 0 0 0 13 26" stroke="#7B417B" strokeWidth="2" strokeLinecap="round" fill="none" />
      <path d="M19 8 A8 8 0 0 1 19 24" stroke="#F18859" strokeWidth="2" strokeLinecap="round" fill="none" />
      <rect x="14.5" y="12" width="1.5" height="8" rx="0.75" fill="#F0ECF8" opacity="0.9" />
      <rect x="17" y="10" width="1.5" height="12" rx="0.75" fill="#F18859" />
      <rect x="19.5" y="13" width="1.5" height="6" rx="0.75" fill="#F0ECF8" opacity="0.6" />
    </svg>
    <span style={{ fontSize: size, fontWeight: 600, letterSpacing: '-0.01em' }}>
      <span style={{ color: '#F0ECF8' }}>Akali </span>
      <span style={{ color: '#F18859' }}>AI</span>
    </span>
  </div>
);

export default LogoBicolor;
